export const v2Paths = [
    "/perfil",
    "/correos",
    "/mis-correos",
    "/viajes",
    "/viajes-completados",
    "/ideas",
    "ideas-completadas",
    "/galeria",
    "/contacto",
    "/recetas",
    "/calculadora-forex",
    "/ganador-aleatorio",
    "/sopa-de-letras",
    "/ranking",
    "/generar-equipos"
];

export const v2Queries = [
    "login=1"
];

export const protectedPaths = [
	"/perfil",
	"/mis-correos",
	"/viajes",
	"/viajes-completados",
	"/ideas",
	"/ideas-completadas",
	"/galeria",
	"/recetas",
	"/sopa-de-letras",
	"/ranking"
];
